import { H2 } from 'app/components/Typography';
import { FlexBox } from '../credential';
import {
  Box,
  Button,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from '@mui/material';
import { Searchbar } from '../presets';
import Loading from 'app/components/MatxLoading';
import usePinterest from './hooks/usePinterest';
import { useRecoilValue } from 'recoil';
import { userPinterestStateAtom } from './atom';
import { useEffect } from 'react';
import { useState } from 'react';
import styled from '@emotion/styled';
import PinterestIcon from '@mui/icons-material/Pinterest';
import { AddCircle, Delete, KeyOutlined } from '@mui/icons-material';
import AddPinterestDialog from './AddPinterestDialog';
import { getFunctions, httpsCallable } from 'firebase/functions';
import { toast } from 'react-toastify';
import { LoadingButton } from '@mui/lab';
import UpgradeDialog from '../UpgradePlanDialog';
import useAuth from 'app/hooks/useAuth';

const StyledTable = styled(Table)(({ theme }) => ({
  whiteSpace: 'pre',
  '& thead': {
    '& tr': { '& th': { paddingLeft: 0, paddingRight: 0 } }
  },
  '& tbody': {
    '& tr': { '& td': { paddingLeft: 0, textTransform: 'capitalize' } }
  }
}));

export const SocialStatus = ({ stat }) => {
  if (!stat || stat === 'live')
    return (
      <span
        style={{
          color: 'white',
          fontWeight: 'bold',
          padding: '5px 10px',
          borderRadius: '5px',
          backgroundColor: 'green'
        }}
      >
        live
      </span>
    );
  else if (stat === 're-auth')
    return (
      <span
        style={{
          color: 'white',
          fontWeight: 'bold',
          padding: '5px 10px',
          borderRadius: '5px',
          backgroundColor: 'red'
        }}
      >
        re-authenticate
      </span>
    );
};

const Pinterest = () => {
  const pinterests = useRecoilValue(userPinterestStateAtom);
  const [filteredData, setFilteredData] = useState(null);
  const [search, setSearch] = useState('');
  const [openAddNew, setOpenAddNew] = useState(false);
  const [currentDeletionId, setCurrentDeletionId] = useState(null);
  const [currentReAuthId, setCurrentReAuthId] = useState(null);
  const [upgradeMsg, setUpgradeMsg] = useState(null);
  const { user } = useAuth();
  const handleAddNew = () => {
    if (
      user?.plan?.social?.pinterest_acc_limit &&
      pinterests.length >= user?.plan?.social?.pinterest_acc_limit
    ) {
      setUpgradeMsg(
        'Pinterest account limit reached. You can only add ' +
          user?.plan?.social?.pinterest_acc_limit +
          ' Pinterest accounts.' +
          ' Please upgrade your plan to add more accounts.'
      );
    } else {
      setOpenAddNew(true);
    }
  };
  const reAuthenticate = async (name, siteId) => {
    setCurrentReAuthId(siteId);
    try {
      const fn = httpsCallable(getFunctions(), 'pinterestRequest');
      const res = await fn({ name, siteId, command: 'getOATUHURL' });

      let url = res.data;

      window.open(url, 'popup', 'width=600,height=600');
    } catch (e) {
      console.error(e);
      toast.error('Failed to re-authenticate Pinterest account');
    }
    setCurrentReAuthId(null);
  };

  const deleteAccount = async (siteId) => {
    setCurrentDeletionId(siteId);
    try {
      const fn = httpsCallable(getFunctions(), 'pinterestRequest');
      await fn({ id: siteId, command: 'delete' });
    } catch (e) {
      console.error(e);
      toast.error('Failed to delete Pinterest account');
    }
    setCurrentDeletionId(null);
  };

  useEffect(() => {
    if (!pinterests) return;

    if (search === '') {
      setFilteredData(pinterests);
    } else {
      setFilteredData(
        pinterests.filter((item) => item.name.toLowerCase().includes(search.toLowerCase()))
      );
    }
  }, [search, pinterests]);

  console.log('filteredData', filteredData);

  usePinterest();

  return (
    <>
      <AddPinterestDialog open={openAddNew} onClose={() => setOpenAddNew(false)} />
      <UpgradeDialog msg={upgradeMsg} setMsg={setUpgradeMsg} />
      <FlexBox style={{ marginTop: '25px' }}>
        <H2
          style={{
            position: 'absolute',
            top: '-25px',
            left: '12px',
            display: 'flex',
            alignItems: 'center',
            gap: '10px'
          }}
        >
          <PinterestIcon fontSize="24px" />
          Pinterest Accounts
        </H2>
        <Button
          startIcon={<AddCircle />}
          style={{ position: 'absolute', right: '20px', top: '-25px' }}
          onClick={handleAddNew}
        >
          Add New Account
        </Button>
      </FlexBox>
      <FlexBox>
        <Box
          sx={{ padding: '10px 20px' }}
          md={{ padding: '15px 25px' }}
          style={{ maxWidth: '1500px' }}
        >
          <TableContainer>
            <FlexBox style={{ justifyContent: 'right' }}>
              <Searchbar placeholder={'Search by name'} setSearch={setSearch} />
            </FlexBox>
            <StyledTable>
              <TableHead>
                <TableRow>
                  <TableCell align="left" width="30%">
                    <b>Name</b>
                  </TableCell>
                  <TableCell align="center" width="25%">
                    <b>Status</b>
                  </TableCell>
                  <TableCell align="center" width="45%">
                    <b>Action</b>
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {!filteredData && (
                  <TableRow>
                    <TableCell rowSpan={3} colSpan={3}>
                      <Loading />
                    </TableCell>
                  </TableRow>
                )}

                {filteredData && filteredData.length == 0 && (
                  <TableRow>
                    <TableCell rowSpan={3} colSpan={3}>
                      <div
                        style={{
                          width: '100%',
                          height: '50px',
                          marginTop: '20px',
                          textAlign: 'center'
                        }}
                      >
                        <h3>No accounts found</h3>
                      </div>
                    </TableCell>
                  </TableRow>
                )}

                {filteredData &&
                  filteredData.map((item, index) => (
                    <TableRow key={item.id}>
                      <TableCell width="30%">{item.name}</TableCell>
                      <TableCell align="center" width="25%">
                        <SocialStatus stat={item.status} />
                      </TableCell>
                      <TableCell align="left" width="45%">
                        <Stack direction="row" spacing={2} width="100%" justifyContent="center">
                          <LoadingButton
                            loading={currentReAuthId === item.id}
                            color="primary"
                            onClick={() => reAuthenticate(item.name, item.id)}
                            startIcon={<KeyOutlined />}
                          >
                            Re-authenticate
                          </LoadingButton>
                          <LoadingButton
                            color="error"
                            onClick={() => deleteAccount(item.id)}
                            loading={currentDeletionId === item.id}
                          >
                            <Delete />
                          </LoadingButton>
                        </Stack>
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </StyledTable>
          </TableContainer>
        </Box>
      </FlexBox>
    </>
  );
};

export default Pinterest;
